
export const ROOM_OPTION_MAP = {
    0: 'Студио',
    1: '1',
    2: '2',
    3: '3',
    4: '4+',
}